import { useSlideContext } from "@/deck/SlideContext";

export default function SlideFrame({ number, tag, children, className = "" }) {
  const ctx = useSlideContext();
  // Auto-derive: "02 / The Team" where idx=1 (cover is 0), total content slides = total-1
  const contentIdx = Math.max(0, ctx.idx); // 0 = cover, 1..N = content
  const contentTotal = Math.max(1, ctx.total - 1);
  const autoNumber =
    contentIdx === 0
      ? `Cover / ${ctx.label || ""}`
      : `${String(contentIdx).padStart(2, "0")} / ${ctx.label || ""}`;
  const displayNumber = number || autoNumber;
  const displayTag = tag || ctx.tag || "";

  return (
    <section className={`relative min-h-[calc(100vh-7rem)] px-6 md:px-14 lg:px-20 py-10 md:py-14 flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-10 md:mb-14 text-[11px] uppercase tracking-brand text-muted-foreground font-mono-data">
        <span>{displayTag}</span>
        <span>{displayNumber}</span>
      </div>
      <div className="flex-1">{children}</div>
      <footer className="mt-12 pt-4 border-t border-foreground/10 text-[10px] font-mono-data text-muted-foreground/80 leading-relaxed">
        All figures and examples in this deck are for illustrative purposes only and do not constitute a guaranty, warranty, or prediction of future performance.
      </footer>
    </section>
  );
}
